import React, { ReactNode, SyntheticEvent } from 'react';
import styled from 'styled-components';
import {
  defaultPermissionTooltipOption,
  ITooltipOption,
} from '../../KubitTooltip/globalTooltips';
import { IconName, IconWrapper, SvgIcon } from '../../Icon';
import { theme } from '../../../styles/theme';
import KubitTooltip from '../../KubitTooltip';

interface IProps {
  label: ReactNode;
  onClick?: (event: SyntheticEvent) => void;
  tooltipOption?: ITooltipOption;
  isActive?: boolean;
  // Use this prop for KubitContextualMenu option when you have a Learn More link
  // in tooltip
  actionLinkAsSpan?: boolean;
  iconName?: IconName;
  hasSubMenus?: boolean;
  isUnPermitted?: boolean;
  isDisabled?: boolean;
  disabledReason?: ITooltipOption;
}

const Content = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  outline: none;
`;
const Label = styled(Content)<{ $isInactive?: boolean; $isActive?: boolean }>`
  column-gap: 8px;
  padding-left: 9px;
  color: ${({ $isInactive, $isActive }) =>
    $isInactive
      ? theme.colors.secondary400
      : $isActive
        ? theme.colors.mainBlue
        : 'inherit'};
`;

const StyledChevronWrapper = styled(IconWrapper)`
  margin-left: auto;
`;

const ContextualMenuOption = ({
  label,
  onClick,
  tooltipOption,
  isActive,
  actionLinkAsSpan,
  iconName,
  hasSubMenus,
  isUnPermitted,
  isDisabled,
  disabledReason,
}: IProps) => {
  const tooltip = isUnPermitted
    ? disabledReason || defaultPermissionTooltipOption
    : isDisabled
      ? disabledReason
      : tooltipOption;
  const isInactive = isUnPermitted || isDisabled;

  return (
    <KubitTooltip
      {...tooltip}
      actionLinkAsSpan={actionLinkAsSpan}
      disabled={!tooltip}
      placement={isInactive ? 'top' : 'right'}
    >
      <Label
        onClick={!isInactive ? onClick : undefined}
        $isInactive={isInactive}
        $isActive={isActive}
      >
        {iconName && (
          <IconWrapper size={16}>
            <SvgIcon
              name={iconName}
              width={16}
              height={16}
              customFill="currentColor"
            />
          </IconWrapper>
        )}
        {label}
        {hasSubMenus && (
          <StyledChevronWrapper size={20}>
            <SvgIcon
              name="caret-right"
              width={16}
              height={16}
              customFill="currentColor"
            />
          </StyledChevronWrapper>
        )}
      </Label>
    </KubitTooltip>
  );
};

export default ContextualMenuOption;
